import { HandPalm, HandsClapping, HandWaving, X } from "phosphor-react";
import { Activity, Team } from "../types";
import { getTeamname, getUsername } from "../utils";

const OpenedActivity = ({
  team,
  activity,
  onClose,
  onClaim,
  onApprove,
  onAbort,
}: {
  team: Team | undefined;
  activity: Activity;
  onClose: () => void;
  onClaim: () => void;
  onApprove: () => void;
  onAbort: () => void;
}) => {
  const getActionButtons = () => {
    const username = getUsername();
    if (!username || activity.status === "finished") {
      return;
    }
    if (activity.status === "available" && team?.activity === "") {
      return (
        <button onClick={onClaim} className="claim-activity-button button">
          CLAIM
        </button>
      );
    }
    if (activity.claimedBy === username) {
      return (
        <div className="claim-activity-button-container">
          <button
            onClick={onAbort}
            className="claim-activity-button orange button"
          >
            ABORT
          </button>
          <button onClick={onApprove} className="claim-activity-button button">
            APPROVE
          </button>
        </div>
      );
    }
  };
  return (
    <div className="opened-activity-wrapper" onClick={onClose}>
      <div
        className="opened-activity-content button"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="close-activity-button" onClick={onClose}>
          <X size={32} weight="bold" />
        </button>
        <h1 className="modal-activity-title">{activity.title}</h1>
        <p className="modal-activity-description">{activity.description}</p>
        <div className="modal-activity-points">
          <p>{activity.points}</p>
        </div>
        {activity.status === "claimed" && activity.claimedBy && (
          <div className="modal-activity-status">
            <HandPalm size={32} />
            <p>
              Claimed by <b>{getTeamname(activity.claimedBy)}</b>
            </p>
          </div>
        )}
        {activity.status === "finished" && activity.claimedBy && (
          <div className="modal-activity-status">
            <HandsClapping size={32} /> Finished by <b>{getTeamname(activity.claimedBy)}</b>
            <p></p>
          </div>
        )}
        {activity.status === "available" && (
          <div className="modal-activity-status">
            <HandWaving size={32} />
            <p>Activity is up for grabs</p>
          </div>
        )}
        {getActionButtons()}
      </div>
    </div>
  );
};

export default OpenedActivity;
